import React, { useEffect, useState } from 'react';
import { userAPI } from '../../../api';
import '../Admin.css';

const AdminUsers: React.FC = () => {
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState('all');
  const PER_PAGE = 20;

  const load = async () => {
    setLoading(true);
    try {
      const res = await userAPI.list();
      setUsers(res.data);
    } catch (e) {}
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const filtered = users.filter(u =>
    filter === 'all' ? true : u.status === filter
  );
  const totalPages = Math.ceil(filtered.length / PER_PAGE);
  const paged = filtered.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  const updateStatus = async (userId: number, status: string) => {
    try {
      await userAPI.updateStatus(userId, status);
      await load();
    } catch (e) { alert('처리 실패'); }
  };

  const deleteUser = async (userId: number) => {
    if (!window.confirm('이 회원을 삭제하시겠습니까?')) return;
    try {
      await userAPI.delete(userId);
      await load();
    } catch (e) { alert('삭제 실패'); }
  };

  const pendingCount = users.filter(u => u.status === 'pending').length;

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div className="admin-page-title">
          <span className="icon">👥</span>
          회원 관리
          {pendingCount > 0 && (
            <span className="badge badge-warning" style={{ fontSize: 12 }}>
              대기 {pendingCount}명
            </span>
          )}
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>전체 {users.length}명</span>
          <select
            className="form-select"
            style={{ width: 'auto' }}
            value={filter}
            onChange={e => { setFilter(e.target.value); setPage(1); }}
          >
            <option value="all">전체</option>
            <option value="pending">대기</option>
            <option value="approved">승인</option>
            <option value="rejected">거부</option>
          </select>
        </div>
      </div>

      <div className="card">
        <div className="card-body" style={{ padding: 0 }}>
          {loading ? (
            <div className="loading-spinner"><div className="spinner" /></div>
          ) : (
            <div className="table-wrap">
              <table className="table">
                <thead>
                  <tr>
                    <th style={{ width: 40 }}>No</th>
                    <th>아이디</th>
                    <th>이메일</th>
                    <th>이름</th>
                    <th>연락처</th>
                    <th>가입일</th>
                    <th>상태</th>
                    <th style={{ width: 180 }}>관리</th>
                  </tr>
                </thead>
                <tbody>
                  {paged.length === 0 ? (
                    <tr><td colSpan={8} style={{ textAlign: 'center', padding: 30, color: 'var(--text-muted)' }}>
                      회원이 없습니다.
                    </td></tr>
                  ) : paged.map((u: any, i: number) => (
                    <tr key={u.id} style={{ background: u.status === 'pending' ? '#fffbeb' : '' }}>
                      <td style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
                        {(page - 1) * PER_PAGE + i + 1}
                      </td>
                      <td style={{ fontWeight: 600 }}>{u.username}</td>
                      <td style={{ color: 'var(--text-muted)' }}>{u.email || '-'}</td>
                      <td>{u.name || '-'}</td>
                      <td style={{ color: 'var(--text-muted)' }}>{u.phone || '-'}</td>
                      <td style={{ color: 'var(--text-muted)', fontSize: 12 }}>
                        {u.created_at?.slice(0, 10)}
                      </td>
                      <td>
                        <span className={`badge ${
                          u.status === 'approved' ? 'badge-success' :
                          u.status === 'rejected' ? 'badge-danger' : 'badge-warning'
                        }`}>
                          {u.status === 'approved' ? '✓ 승인' : u.status === 'rejected' ? '✗ 거부' : '⏳ 대기'}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 4 }}>
                          {u.status !== 'approved' && (
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => updateStatus(u.id, 'approved')}
                            >승인</button>
                          )}
                          {u.status === 'approved' && (
                            <button
                              className="btn btn-warning btn-sm"
                              onClick={() => updateStatus(u.id, 'pending')}
                            >취소</button>
                          )}
                          {u.status !== 'rejected' && (
                            <button
                              className="btn btn-ghost btn-sm"
                              onClick={() => updateStatus(u.id, 'rejected')}
                            >거부</button>
                          )}
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => deleteUser(u.id)}
                          >삭제</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {/* 페이지네이션 */}
          {totalPages > 1 && (
            <div className="pagination">
              <button className="page-btn" onClick={() => setPage(p => Math.max(1, p - 1))}>◀</button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                <button
                  key={p}
                  className={`page-btn ${p === page ? 'active' : ''}`}
                  onClick={() => setPage(p)}
                >{p}</button>
              ))}
              <button className="page-btn" onClick={() => setPage(p => Math.min(totalPages, p + 1))}>▶</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminUsers;
